import { render } from "./ServicioCreate.vue?vue&type=template&id=1b61d990&scoped=true"
import script from "./ServicioCreate.vue?vue&type=script&lang=js"
export * from "./ServicioCreate.vue?vue&type=script&lang=js"

import "./ServicioCreate.vue?vue&type=style&index=0&id=1b61d990&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b61d990"]])

export default __exports__